// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__Vm+M9","shortcut":"mimic___style_shortcut__YPxkU","supportingText":"mimic___style_supportingText__wrWuH"};